import PropTypes from "prop-types";
import { createContext, useContext, useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material";
import theme from "assets/theme";
import MDSnackbar from "components/MDSnackbar";

// Creamos el contexto
const NotificationContext = createContext();

// Hook personalizado para acceder al contexto
export const useNotification = () => useContext(NotificationContext);

// Proveedor del contexto
export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    icon: "",
    message: "",
    severity: "info", // info | success | warning | error
    button: null, // { name: "Action", link: "/path" }
  });

  const [autoHideDuration, setAutoHideDuration] = useState(3000); 

  const showNotification = (message, severity = "info", icon = "", button=null) => {
    setNotification({ open: true, icon, message, severity, button });
  };

  const closeNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    if (notification.open) {
      const timer = setTimeout(() => {
        setAutoHideDuration(6000);
        closeNotification();
      }, autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, [notification.open, autoHideDuration]);


  return (
    <NotificationContext.Provider value={{ showNotification }}>
      <ThemeProvider theme={theme}>
        {children}
        <MDSnackbar
          icon={notification.icon}
          content={notification.message}
          color={notification.severity}
          open={notification.open}
          close={closeNotification}
          autoHideDuration={autoHideDuration}
          button={notification.button}
        />
      </ThemeProvider>
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};